view_handler = {

    properties: {
        title: 'View/Add Comments',
        featureID: ''
    },

    onLoad: function(){
        var self = this;


        self.properties.featureID = window.location.hash.substring(2).split('/')[1];
        var id = self.properties.featureID;

        //check to see if this feature exists
        if (!feedbackData.data[id]){
            window.location.href = "#/";
        }
        else {
            self.getData();
            home_handler.tempSidebar();
            self.highlightSelection(id);
        }

    },

    resetSelection: function(){
        var self = this;
        $('.comment-selected').removeClass('comment-selected');
    },

    highlightSelection: function(id){
        var self = this;
        self.resetSelection();
        $('#comment-' + id).addClass('comment-selected');
    },

    getData: function(){
        var self = this;
        var data = feedbackData.data[self.properties.featureID];

        //Set Suggestion's initial comment
        if (data.comment){
            $('.suggestion-comment').html('<p class="no-mp">"' + data.comment + '" - <b>'+data.name+'</b></p>').removeClass('hidden');
        }

        likes_handler.getLikes(self.properties.featureID);
        comments_handler.getComments(self.properties.featureID);

    },

    events: function() {
        var self = this;
        self.onLoad();

        $("#comment-submit").submit(function(event) {
            comments_handler.addComment(event, self.properties.featureID);
        });

        $('.content-close-btn').click(function(event) {
            self.resetSelection();
            window.location.href = "#/" + properties.previousURL;
            return false;
        });

        $('textarea[name=comment]').on('input click', function() {
            var wordCount = home_handler.wordCount($(this).val());
            if (wordCount > self.properties.wordLimit){
                $('.story-word').text(self.properties.wordLimit);
                $(this).addClass('required');
                $('.story-min').addClass('required');
            }
            else {
                $('.story-min').removeClass('required');
                $(this).removeClass('required');
                $('.story-word').text(wordCount);
            }
        });


    }
}